import cardgridActions from './destinationCardGrid';

const noop = () => {};
const actions = {
	default: noop,
	cardgrid: cardgridActions,
};

const getAction = event => {
	const [namespace, type] = event.split('.');
	return actions[namespace][type] || actions.default;
};

export const resolveClientDependency = () => {
	if (window.FS.Tealium.clientDependencyResolved) {
		window.FS.Tealium.clientDependencyResolved();
	}
};

export const triggerEvent = (type, action, payload, thisArg) => {
	if (thisArg) {
		window.FS.Tealium.trackInteraction(type, action, payload, thisArg);
	} else {
		window.FS.Tealium.trackInteraction(type, action, payload);
	}
};

const inheritedProperties = [
	'aa_account',
	'site_prefix',
	'site_template',
	'page_url',
	'aem_url',
	'page_language',
	'property_name',
	'property_code',
	'property_region',
	'property_subregion',
	'page_detail',
];

export const triggerPageView = data => {
	//copy initial fields from global utag_data
	let inheritedPageData = {};
	if (window.utag_data) {
		inheritedProperties.forEach(trackingProp => {
			if (window.utag_data[trackingProp]) {
				inheritedPageData[trackingProp] = window.utag_data[trackingProp];
			}
		});
	}
	window.FS.Tealium.trackPage(Object.assign({}, inheritedPageData, data));
};

export default function triggerAnalyticsEvent(event, payload, thisArg) {
	payload.element = $(payload.element);
	payload.element.data('track-interactions') ? getAction(event)(payload, thisArg) : noop();
}
